export default function TravelCardModalSkeleton() {
  return (
    <div className='w-full h-dvh'>
      <div className='w-full max-w-480pxr bg-white h-56pxr py-16pxr px-20pxr flex items-center justify-between'>
        <div className='w-24pxr h-24pxr'></div>
        <div className='w-80pxr h-24pxr rounded-2pxr skeleton-item'></div>
        <div className='w-24pxr h-24pxr'></div>
      </div>
      <div className='w-full h-[calc(100dvh-56px-98px)] overflow-y-scroll'>
        <div className='w-full aspect-[360/200] skeleton-item'></div>
        <div className='px-20pxr pt-20pxr flex flex-col gap-20pxr'>
          <div className='flex flex-col gap-12pxr'>
            <div className='flex items-center gap-2pxr'>
              <div className='w-90pxr h-23pxr rounded-2pxr skeleton-item'></div>
              <div className='w-45pxr h-15pxr rounded-2pxr skeleton-item'></div>
            </div>
            <div className='w-full h-60pxr rounded-2pxr skeleton-item'></div>
          </div>

          <div className='flex flex-col gap-12pxr'>
            <div className='grid grid-cols-3 gap-8pxr'>
              <div className='w-full h-94pxr rounded-6pxr skeleton-item'></div>
              <div className='w-full h-94pxr rounded-6pxr skeleton-item'></div>
              <div className='w-full h-94pxr rounded-6pxr skeleton-item'></div>
            </div>
            <div className='w-full h-32pxr rounded-6pxr skeleton-item'></div>
          </div>
        </div>

        <div className='w-full mt-30pxr'>
          <div className='w-1/2 mx-20pxr h-20pxr rounded-2pxr skeleton-item mb-8pxr'></div>
          <div className='w-full h-76pxr border-b border-new-gray-200 px-20pxr py-8pxr flex flex-row gap-12pxr items-center'>
            <div className='w-60pxr h-60pxr rounded-6pxr skeleton-item'></div>
            <div className='flex flex-col gap-4pxr flex-1'>
              <div className='w-1/3 h-18pxr rounded-2pxr skeleton-item'></div>
              <div className='w-2/3 h-20pxr rounded-2pxr skeleton-item'></div>
            </div>
          </div>
          <div className='w-full h-76pxr border-b border-new-gray-200 px-20pxr py-8pxr flex flex-row gap-12pxr items-center'>
            <div className='w-60pxr h-60pxr rounded-6pxr skeleton-item'></div>
            <div className='flex flex-col gap-4pxr flex-1'>
              <div className='w-1/3 h-18pxr rounded-2pxr skeleton-item'></div>
              <div className='w-2/3 h-20pxr rounded-2pxr skeleton-item'></div>
            </div>
          </div>
          <div className='w-full h-76pxr border-b border-new-gray-200 px-20pxr py-8pxr flex flex-row gap-12pxr items-center'>
            <div className='w-60pxr h-60pxr rounded-6pxr skeleton-item'></div>
            <div className='flex flex-col gap-4pxr flex-1'>
              <div className='w-1/3 h-18pxr rounded-2pxr skeleton-item'></div>
              <div className='w-2/3 h-20pxr rounded-2pxr skeleton-item'></div>
            </div>
          </div>
          <div className='w-full h-76pxr border-b border-new-gray-200 px-20pxr py-8pxr flex flex-row gap-12pxr items-center'>
            <div className='w-60pxr h-60pxr rounded-6pxr skeleton-item'></div>
            <div className='flex flex-col gap-4pxr flex-1'>
              <div className='w-1/3 h-18pxr rounded-2pxr skeleton-item'></div>
              <div className='w-2/3 h-20pxr rounded-2pxr skeleton-item'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='max-w-480pxr w-full bg-white h-98pxr px-20pxr pt-16pxr pb-32pxr'>
        <div className='w-full h-50pxr rounded-8pxr skeleton-item'></div>
      </div>
    </div>
  );
}
